import { render } from "./form-part-a-practice-areas.html?vue&type=template&id=7dd6d2b0&scoped=true&ts=true&external"
import script from "./form-part-a-practice-areas.ts?vue&type=script&lang=ts&external"
export * from "./form-part-a-practice-areas.ts?vue&type=script&lang=ts&external"

import "./form-part-a-practice-areas.scss?vue&type=style&index=0&id=7dd6d2b0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd6d2b0"]])

export default __exports__